import { defineMessages } from "react-intl";
const messages = defineMessages({
    preparing: {
        id: "app.aiDiscoverability.common.exportStatusBanner.preparing",
        defaultMessage: "Preparing download. This can take a minute – <b>keep this window open</b>.",
    },
    success: {
        id: "app.aiDiscoverability.common.exportStatusBanner.success",
        defaultMessage: "File ready. download will automatically occur.",
    },
    successPartial: {
        id: "app.aiDiscoverability.common.exportStatusBanner.successPartial",
        defaultMessage: " — {included} exported, {skipped} skipped.",
    },
    error: {
        id: "app.aiDiscoverability.common.exportStatusBanner.error",
        defaultMessage: "Download failed, ",
    },
    nothingToExport: {
        id: "app.aiDiscoverability.common.exportStatusBanner.nothingToExport",
        defaultMessage: "Nothing to export — no selected community has a completed report. ",
    },
    retry: {
        id: "app.aiDiscoverability.common.exportStatusBanner.retry",
        defaultMessage: "retry now",
    },
    dismiss: {
        id: "app.aiDiscoverability.common.exportStatusBanner.dismiss",
        defaultMessage: "Dismiss",
    },
});
export default messages;
